export default "__VITE_ASSET__Bjbad67j__"